module.exports = __webpack_public_path__ + "static/media/_DSC6162.c8e5531d.jpg";